import { useEffect, useState } from "react";

import { type ViewSpec } from "@moment/api-collab/api-types";
import { type TableMutation } from "@moment/api-collab/differential";
import { useCellServices } from "@moment/design-system/CellServicesContext";

export const useBaseViewQuery = (viewId: string) => {
	const { base } = useCellServices();

	const [viewSpec, setViewSpec] = useState<ViewSpec | undefined>(undefined);
	useEffect(() => {
		if (!base) {
			return;
		}
		const unsubscribe = base.subscribeMetadata((baseSpec) =>
			setViewSpec(baseSpec.views[viewId])
		);
		return () => unsubscribe?.();
	}, [base, viewId]);

	const query = viewSpec?.query;

	const [results, setResults] = useState<unknown[]>([]);
	const [changes, setChanges] = useState<TableMutation<unknown>[]>([]);

	useEffect(() => {
		if (!query) {
			return;
		}

		const unsubscribe = base?.subscribeQuery(query, (results, changes) => {
			setResults(results);
			setChanges(changes);
		});
		return () => unsubscribe?.();
	}, [query, base]);

	return { viewSpec, results, changes };
};
